export default {
	install(Vue) {
		Vue.filter('price', function(input) {
			return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
		});
	}
}